import React from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import { appRoutes } from '../path';
import reportRoutes from './Formulas/ReportRoutes';
import dashboardRoutes from './DashboardRoute/DashboardRoutes';
import dataModelerRoutes from './DataModeler/DataModelerRoutes';
import dictionaryRoutes from './Dictionary/DictionaryRoutes';
import incidentRoutes from './Incidents/IncidentRoutes';
import Auth from './Auth';
import { Bootstrap } from '../components/Bootstrap';
import Layout from '../Layout';
import System from './System';
import { IS_LOCALHOST } from '../config/constants';
import Debug from './Debug';
import SchemaRequiredRoute from './SchemaRequiredRoute';
import RedirectRoute from './RedirectRoute';
import cohortRoutes from './Cohorts/CohortRoutes';
import scheduleRoutes from './Schedule/ScheduleRoutes';
import settingsRoutes from './Settings/SettingsRoutes';
import workspaceRoutes from './Workspaces/WorkspacesRoute';
import Home from './Home';
import SlackOAuthCallback from '../components/Slack/SlackOAuthCallback';
import SlackOAuthStart from '../components/Slack/SlackOAuthStart';
import DebugLlm from './DebugLlm';
import embedRoute from './EmbedRoutes/EmbedRoutes';
import LoadGeoMap from '../Layout/LoadGeoMap';

const protectedRoutes: RouteObject[] = [
  {
    element: (
      <Auth>
        <Bootstrap>
          <LoadGeoMap />
          <Outlet />
        </Bootstrap>
      </Auth>
    ),
    children: [
      {
        element: <Layout />,
        children: [
          {
            element: <SchemaRequiredRoute />,
            children: [
              {
                index: true,
                path: appRoutes.home,
                element: <Home />,
              },
              ...reportRoutes,
              ...cohortRoutes,
              ...dashboardRoutes,
              ...dictionaryRoutes,
              ...scheduleRoutes,
              ...incidentRoutes,
              ...workspaceRoutes,
            ],
          },
          ...settingsRoutes,
          ...dataModelerRoutes,
          {
            path: '/help',
            element: <RedirectRoute from="/help" to={appRoutes.system} />,
          },
          {
            path: appRoutes.system,
            element: <System />,
          },
          // Debug routes for localhost
          ...(IS_LOCALHOST
            ? [
                {
                  path: appRoutes.debug,
                  element: <Debug />,
                },
              ]
            : []),
          // XXX this is protected by a special feature flag - AI_DEBUG,
          // only available to CSEs
          {
            path: appRoutes.debugLlm77,
            element: <DebugLlm />,
          },
          {
            path: '/slack/callback',
            element: <SlackOAuthCallback />,
          },
          {
            path: '/slack/oauth',
            element: <SlackOAuthStart />,
          },
        ],
      },
      embedRoute,
    ],
  },
];

export default protectedRoutes;
